import type { TempBand } from '../../state/app-state.js';

export type Scene = 'personal-loan' | 'business-credit' | 'agricultural';

const SCENE_LINES: Record<Scene, string> = {
  'personal-loan':
    'A friendly suburban street with a single welcoming house, blue sky.',
  'business-credit':
    'A small service-business storefront seen from across the street — auto repair shop or hardware store. The storefront has wide front windows, a friendly entrance, and a roof line. CRITICAL: the building has NO sign, NO banner, NO awning text, NO window decals, NO numbers, NO letters of any kind anywhere — neither over the door nor in the windows nor on the wall nor on the sidewalk. Where a sign would normally hang, render the wall as plain bare brick or wood with no markings. The entire scene is wordless.',
  'agricultural':
    'An open farm field with a tractor, a distant red barn, and big sky.',
};

const BAND_LINES: Record<TempBand, string> = {
  cold: 'Snow on the ground, bare trees, soft winter light.',
  temperate: 'Bright, mild day with light optimistic mood.',
  hot: 'Blazing sun, sun-bleached colors, heat shimmer in the distance.',
};

export function scenePrompt(scene: Scene, band: TempBand, companyName: string): string {
  return [
    'Cartoonish, infographic-style illustration.',
    SCENE_LINES[scene],
    BAND_LINES[band],
    `Lower 18% of the frame is a clean dark band — it will be overlaid by branding outside the image. The rest of the frame is bright, optimistic, and aimed at advertising for ${companyName}.`,
    'Strictly no text, no letters, no numbers, no words, no signage with text, no shop names visible, no street signs, no labels.',
    'No logos of any company, no brand marks, no watermarks anywhere in the image.',
    'Pure imagery only. Aspect 16:9.',
  ].join(' ');
}
